var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("SalaryEdit", {
            attrs: { inline: false, "placeholder-non-range": "zB: 25" },
            on: { input: _vm.emitChangeEvent },
            scopedSlots: _vm._u([
              {
                key: "input-info",
                fn: function() {
                  return [
                    _c("div", [
                      _vm._v("Dein Mindeststundensatz - "),
                      _c("b", [_vm._v("Brutto")]),
                      _vm._v(" vor Abzug der Steuern.")
                    ])
                  ]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.hourlyRate,
              callback: function($$v) {
                _vm.hourlyRate = $$v
              },
              expression: "hourlyRate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("InfoBox", { staticClass: "mt-4" }, [
        _vm._v(
          "\n\t\tDein genauer Stundensatz wird ArbeitgeberInnen nicht angezeigt, sondern dient nur dem Matching bzw.\n\t\tdem Ermitteln, ob ein Job passt.\n\t"
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }